module.exports = __webpack_public_path__ + "static/media/icons8-trash.2b6f8fb8.svg";